export default __webpack_public_path__ + "static/poster-9e3132306a6cfa45a53dc3bea908211f.png";